import toast from "react-hot-toast";

export default function ScanQRCode({ data }) {
  return (
    <div className="row row-sm">
      <div className="css-weqpav mt-2">
        <div className="css-1xfmg0p">
          <img
            height="96"
            width="96"
            style={{ height: "96px", width: "96px" }}
            alt="qr code"
            src={data.google2fa_qrcode}
          />
        </div>
        <div className="css-wiulhc"></div>
        <div className="css-1t5xnih">
          <div className="css-vurnku">
            If you are unable to scan the QR code, please enter this code
            manually into the app.
          </div>
          <div className="css-1gv6rnn">
            <div
              className="css-ryy4eq"
              onClick={() => {
                navigator.clipboard
                  .writeText(data.backup_key)
                  .then(() => {
                    toast.success("Copied to clipboard");
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }}
            >
              {data.google2fa_code}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
